import React from 'react';
import { motion, useAnimation } from 'framer-motion';
import { FaLinkedin, FaTwitter, FaEnvelope } from 'react-icons/fa';
import './leadership.css';

function Leadership() {


  return (

    <>
    <motion.div 
      className="leadership-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="leadership-header">
        <motion.h1
          initial={{ y: -20 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Our Leadership Team
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Guiding Ceylon Eye Care Optometry Association with vision and expertise
        </motion.p>
      </div>

      <motion.div 
        className="leadership-intro"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        <p>
          Our leadership team brings together decades of experience in optometry practice, 
          education, and healthcare administration. Committed to advancing eye care standards 
          in Sri Lanka, they guide our strategic direction and member services.
        </p>
      </motion.div>
    </motion.div>


{/* Leadership Section */}
<section className="leadership-section">
  <div className="section-header">
    <h2>Our Leadership</h2>
    <div className="divider"></div>
  </div>
  
  <div className="leadership-grid">
    {/* Main Leadership Cards (Founder, Chairmen, etc.) */}
    <div className="main-leaders-grid">
      {/* Founder */}
      <motion.div 
        className="leader-card founder-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <div className="leader-image">
          <img src="/members/062.jpg" alt="Optom. Naresh Pradhan" />
        </div>
        <div className="leader-info">
          <h4>Optom. Naresh Pradhan</h4>
          <p className="position">Founder</p>
          <p className="bio">Visionary founder who established the organization's core principles and direction.</p>
        </div>
      </motion.div>

      {/* Chairman Eye Care Group */}
      <motion.div 
        className="leader-card chairman-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        viewport={{ once: true }}
      >
        <div className="leader-image">
          <img src="/members/072.jpg" alt="Optom. M A D Deshapriya" />
        </div>
        <div className="leader-info">
          <h4>Optom. M A D Deshapriya</h4>
          <p className="position">Chairman Eye Care Group</p>
          <p className="bio">Leads the strategic vision and oversees all eye care initiatives.</p>
        </div>
      </motion.div>

      {/* Chairman */}
      <motion.div 
        className="leader-card chairman-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <div className="leader-image">
          <img src="/members/075.jpg" alt="Optom. Nishamani Duruge" />
        </div>
        <div className="leader-info">
          <h4>Optom. Nishamani Duruge</h4>
          <p className="position">Chairman</p>
          <p className="bio">Provides executive leadership and governance oversight.</p>
        </div>
      </motion.div>

      {/* Registrar */}
      <motion.div 
        className="leader-card registrar-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        viewport={{ once: true }}
      >
        <div className="leader-image">
          <img src="/members/046.jpg" alt="Optom. Erandi Perera Siriwardane" />
        </div>
        <div className="leader-info">
          <h4>Optom. Erandi Siriwardane</h4>
          <p className="position">Registrar</p>
          <p className="bio">Manages official records and regulatory compliance.</p>
        </div>
      </motion.div>

      {/* Treasurer */}
      <motion.div 
        className="leader-card treasurer-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        viewport={{ once: true }}
      >
        <div className="leader-image">
          <img src="/members/079.jpg" alt="Optom. K Lahiru M Rodrigo" />
        </div>
        <div className="leader-info">
          <h4>Optom. K L M Rodrigo</h4>
          <p className="position">Treasurer</p>
          <p className="bio">Oversees financial management and budgeting.</p>
        </div>
      </motion.div>


    </div>

    {/* Board of Directors */}
    <div className="directors-section">
      <h3 className="directors-title">Board of Directors</h3>
      <div className="directors-grid">
        {[
          { name: "Optom. Nadarajan Arulkumar", image: "/members/066.jpg" },
          { name: "Optom. J A Lasantha Deepal", image: "/members/077.jpg" },
          { name: "Optom. Mshanama D Priyantha", image: "/members/041.jpg" },
          { name: "Optom. M H M S P Thilakarathne", image: "/members/070.jpg" },
          { name: "Optom. H D S R Wijethunga", image: "/members/073.jpg" },
          { name: "Optom. A D Isuru Sampath", image: "/members/071.jpg" }
        ].map((director, index) => (
          <motion.div 
            key={index}
            className="director-card"
            whileHover={{ y: -5 }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.5 + (index * 0.05) }}
            viewport={{ once: true }}
          >
            <div className="director-image">
              <img src={director.image} alt={director.name} />
            </div>
            <div className="director-info">
              <h5>{director.name}</h5>
              <p className="position">Board Member</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>

    {/* Counsellors */}
    <div className="counsellors-section">
      <h3 className="counsellors-title">Counsellors</h3>
      <div className="counsellors-grid">
        {[
          { name: "Optom. Nadarajan Arulkumar", image: "/members/066.jpg" },
          { name: "Optom. N Udeni Gurusinghe", image: "/members/043.jpg" },
          { name: "Optom. Nishamani Duruge", image: "/members/075.jpg" }
        ].map((counsellor, index) => (
          <motion.div 
            key={index}
            className="counsellor-card"
            whileHover={{ y: -5 }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.8 + (index * 0.05) }}
            viewport={{ once: true }}
          >
            <div className="counsellor-image">
              <img src={counsellor.image} alt={counsellor.name} />
            </div>
            <div className="counsellor-info">
              <h5>{counsellor.name}</h5>
              <p className="position">Counsellor</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>


{/* Media Chairperson */}

{/* <div className="media-chair-section">
  <h3 className="media-chair-title">Media Chairperson</h3>
  <div className="media-chair-grid">
    {[
      { name: "Optom. Ranjith Premarathne", image: "/members/068.jpg" }
    ].map((person, index) => (
      <motion.div 
        key={index}
        className="media-chair-card"
        whileHover={{ y: -5 }}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.8 + (index * 0.05) }}
        viewport={{ once: true }}
      >
        <div className="media-chair-image">
          <img src={person.image} alt={person.name} />
        </div>
        <div className="media-chair-info">
          <h5>{person.name}</h5>
          <p className="position">Media Chairperson</p>
        </div>
      </motion.div>
    ))}
  </div>
</div> */}


  </div>
</section>
</>
  );
}

export default Leadership;